import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
const useStyles = makeStyles((theme) => {
  return {
    carouselBox:{
      // marginTop:126,
      // [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
      //   marginTop:164,
      // },
     
    },
    // '.carousel *':{
    //   [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
    //     height:150,
    //   },
    // },
    carouselBtn: {
      textTransform: "none",
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      //borderColor: myTheme.palette.secondary.light,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
      },
      position: "absolute",
      top: "70%",
      left: "21%",
      transform: "translate(-50%, -50%)",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0,
      },
    },
    carouselImgText: {
      fontSize: 12,
    },
    carouselImg: {
     
    },
    servicesBox: {
      paddingLeft: theme.spacing(myTheme.padding.left + 3.3),
      paddingRight: theme.spacing(myTheme.padding.right),
      paddingTop: theme.spacing(2.5),
      paddingBottom: theme.spacing(2.5),
      //paddingTop: theme.spacing(2)
      display: "flex",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        justifyContent: "center",

        margin: "auto",
      },
      [theme.breakpoints.down(1030)]: {
        //paddingTop: theme.spacing(2),
        paddingRight: 0,
        margin: "auto",
        justifyContent: "center",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: 0,
        paddingRight: 0,
        //marginLeft:'15%'
      },
    },
    service: {
      display: "flex",
      marginRight: theme.spacing(7),
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        marginRight: theme.spacing(0),
      },
      [theme.breakpoints.down(1310)]: {
        paddingTop: theme.spacing(2),
        // marginRight:theme.spacing(17),
        margin: "auto",
        justifyContent: "center",
      },
    },
    serviceIcon: {
      fontSize: "70px",
      color: myTheme.palette.primary.main,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize: "50px",
      },
    },
    serviceText: {
      fontWeight: "bold",
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
    serviceTextLight: {
      color: "grey",
      paddingLeft: theme.spacing(2),
      fontSize: 14,
      whiteSpace: "noWrap",
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        //marginBottom: theme.spacing(5)
      },
    },
    servicesTextBox: {
      paddingLeft: 5,
      [theme.breakpoints.down(1310)]: {
        //paddingTop: theme.spacing(2),
        marginRight: theme.spacing(17),
        margin: "auto",
        justifyContent: "center",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        //paddingTop: theme.spacing(2),
        marginRight: theme.spacing(2),
        margin: "auto",
        justifyContent: "center",
        alignItems: "center",
      },
    },
    //ROW IMAGES SECTION
    mainConatinerAfterServices: {
      flexGrow: 1,
      paddingLeft: theme.spacing(myTheme.padding.left + 3.5),
      paddingRight: theme.spacing(myTheme.padding.right + 4),
      paddingTop: theme.spacing(2.5),
      paddingBottom: theme.spacing(2.5),
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(myTheme.padding.left - 9),
        paddingRight: theme.spacing(myTheme.padding.right - 9),
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(myTheme.padding.left - 11),
        paddingRight: theme.spacing(myTheme.padding.right - 11),
      },
    },
    rowImg: {
      height: 240,
      width: "100%",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        height: 200,
      },
    },

    //DEALS BOX SECTION
    dealsBox: {
      marginTop: theme.spacing(4),
    },
    DealsHeaderTextBox: {
      display: "flex",
      [theme.breakpoints.down(600)]: {
        flexDirection: "column",
      },
    },
    dealsOfDayText: {
      [theme.breakpoints.down(572)]: {
        fontSize: 25,
      },
    },
    timerText: {
      color: myTheme.palette.primary.main,
      [theme.breakpoints.down(572)]: {
        fontSize: 25,
      },
      [theme.breakpoints.down(500)]: {
        marginTop: 10,
      },
    },
    DealProductsCardsScrollBox: {
      overflow: "auto",
      display: "flex",
      animation: "7s delay-overflow",
      'scroll-behavior':'smooth'
    },
    navDealProductsBtnBox: {
      margin: "auto",
      position: "sticky",
      marginRight: 0,
    },
    
    navDealProductsBtn: {
      // border:'1px solid silver',
      // color:'grey',
      // borderRadius: 200,
      // padding: "0",
      // minWidth: "fit-content",
      // marginLeft:13,
      // "&:hover": {
      //   backgroundColor: myTheme.palette.primary.dark,
      //   //color: myTheme.palette.primary.contrastText,
      // },
    },
    categoriesMainBox: {
      //display:'flex',
      marginTop: theme.spacing(5),
      backgroundColor: "#ffffff",
      padding: 20,
      paddingLeft: 0,
    },
    LinkOfCategories: {
      marginLeft: 5,
      "&:hover": {
        textDecoration:'underline',
        color: "#666",
      },
      textDecoration:'none'
    },
    imgCategoryNameText: {
      position: "absolute",
      color: "white",
      top: 27,
      left: "50%",
      transform: "translateX(-50%)",
    },
    categoryMainImgGrid: {
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        //width:'100%',
        marginLeft: 17,
        textAlign: "center",
      },
    },
    categoryMainImg1: {
      width: 407,
      textAlign: "center",
      borderRadius:'10',
      border:'none',
      maxHeight:'605px',
      [theme.breakpoints.down(1296)]: {
        width: 330,
        height: 513,
        marginTop: 10,
        textAlign: "center",
      },
      [theme.breakpoints.down(1260)]: {
        width: "100%",
        marginLeft: 10,
        textAlign: "center",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        //width:'100%',
        marginLeft: 27,
        textAlign: "center",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        //width:'100%',
        marginLeft: 0,
        textAlign: "center",
      },
      // [theme.breakpoints.down(1260) && theme.breakpoints.up(1200)]: {
      //   width:'90%',
      //   marginLeft:10,
      //   textAlign:'center',
      // },
    },
    imgMainText: {
      position: "absolute",
      color: "white",
      top: 100,
      left: "50%",
      marginTop:'10px',
      transform: "translateX(-50%)",
    },
    btnCategoryImageBuyNow: {},
    mainImgOfCategory: {
      //       width: '100%',
      // height: '100%',
      // objectFit: "cover"
    },
    subCategoryImgMainBox: {
      textAlign: "center",
      [theme.breakpoints.down(myTheme.breakpoints.values.lg)]: {
        marginLeft: 17,
        marginBottom: 10,
      },
      [theme.breakpoints.down(1260) && theme.breakpoints.down(1200)]: {
        marginLeft: 25,
        // maxWidth:'100%',
        // flexBasis:'100%'
      },
      [theme.breakpoints.down(750)]: {
        //marginLeft:'10%',
        marginBottom: 10,
      },
      [theme.breakpoints.down(604)]: {
        // marginLeft:'17%',
        // marginRight:'17%',
        width: "100%",
        marginBottom: 10,
        marginLeft: 10,
      },
    },
    subCategoryImgButton: {
      paddingLeft: 18,
      paddingRight: 18,
      textAlign: "center",
      backgroundColor: "#F4F2FD",
      borderRadius: 5,
      "&:hover": {
        backgroundColor: "#F4F2FD",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      },
      [theme.breakpoints.down(604)]: {
        // marginLeft:'17%',
        // marginRight:'17%',
        width: "100%",
      },
      [theme.breakpoints.down(1100)]: {
        // marginLeft:'17%',
        // marginRight:'17%',
        width: "100%",
      },
    },
    spanBtn: {
      textAlign: "center",
      padding: 10,
      paddingTop: 28,
      justifyContent: "center",
      marginTop: 0,
      height: "278px",
      [theme.breakpoints.down(1296)]: {
        height: "230px",
        padding: 5,
        paddingTop: 18,
        textAlign: "center",
      },
      [theme.breakpoints.down("sm")]: {
        height: "230px",
        padding: 20,
        textAlign: "center",
      },
      [theme.breakpoints.down(1260) && theme.breakpoints.up(1200)]: {
        padding: 3,
        paddingTop: 25,
      },
    },
    subCategoryImgGrid: {
      margin: 10,
      marginBottom: 19,
      borderRadius: 5,
      float: "left",
      //marginTop:30,
      marginTop: 0,
      //marginBottom:16,

      //margin:'10 auto',
      marginRight: 5,
      boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
      backgroundColor: "#F4F2FD",
      textAlign: "center",
      flexDirection: "column",
      [theme.breakpoints.down(1296)]: {
        margin: 5,
        marginBottom: 10,
      },
      [theme.breakpoints.down(1200)]: {
        width: "48%",
      },
      [theme.breakpoints.down(604)]: {
        width: "100%",
      },
    },
    ImgSubCategory: {
      padding: 10,
      textAlign: "center",
      margin: "auto",
      justifyContent: "center",
      width: 200,
      height: 160,
      objectFit: "contain",
      [theme.breakpoints.down(1296)]: {
        width: 170,
        height: 130,
        padding: 5,
      },
      // [theme.breakpoints.down(1260) && theme.breakpoints.up(1201)]: {
      //   width:130,
      //   height:90,
      //   padding:0,
      // },
      //paddingBottom:10
      //paddingLeft:5
    },
    loadingImgDiv:{
      alignItems:'center', 
      justifyContent:'center',
      display:'flex'
    }
  };
});

export default useStyles;
